import React from 'react';
import ProductItemWrapper from '../productItem/productItemWrapper';
import './product-list_templates.scss';

export const Template2ColsR1xC1 = props => {
  const { order, contentSpot, contentSpotsDomElements, products, updateContentSpotRefs } = props;
  return (
    <div className={`product-list-grid product-list-grid__container product-list-grid__container--${order}`}>
      <div className="col col:x2" ref={updateContentSpotRefs}>
        <div
          dangerouslySetInnerHTML={{
            __html: contentSpotsDomElements[contentSpot.id],
          }}
          className="grid__content-spot"
        />
      </div>
      <div className="col col:x2">
        <div className="product-list-grid__container">
          {products.map(product => (
            <div key={`t2cr1c1_${product.id}`} className="col col:x1">
              <ProductItemWrapper uniqueTemplateKey="t2cr1c1" product={product} {...props} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export const Template3ColsR1xC1 = props => {
  const { order, contentSpot, contentSpotsDomElements, products, updateContentSpotRefs } = props;
  return (
    <div className={`product-list-grid product-list-grid__container product-list-grid__container--${order}`}>
      <div className="col col:x3" ref={updateContentSpotRefs}>
        <div
          dangerouslySetInnerHTML={{
            __html: contentSpotsDomElements[contentSpot.id],
          }}
          className="grid__content-spot"
        />
      </div>
      <div className="col col:x3-2">
        <div className="product-list-grid__container">
          {products.map(product => (
            <div key={`t3cr1c1_${product.id}`} className="col col:x2">
              <ProductItemWrapper uniqueTemplateKey="t3cr1c1" product={product} {...props} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export const Template4ColsR1xC1 = props => {
  const { order, contentSpot, contentSpotsDomElements, products, updateContentSpotRefs } = props;
  return (
    <div className={`product-list-grid product-list-grid__container product-list-grid__container--${order}`}>
      <div className="col col:x4" ref={updateContentSpotRefs}>
        <div
          dangerouslySetInnerHTML={{
            __html: contentSpotsDomElements[contentSpot.id],
          }}
          className="grid__content-spot"
        />
      </div>
      <div className="col col:x4-3">
        <div className="product-list-grid__container">
          {products.map(product => (
            <div key={`t4cr1c1_${product.id}`} className="col col:x3">
              <ProductItemWrapper uniqueTemplateKey="t4cr1c1" product={product} {...props} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export const Template3ColsR1xC2 = props => {
  const { order, contentSpot, contentSpotsDomElements, products, updateContentSpotRefs } = props;
  return (
    <div className={`product-list-grid product-list-grid__container product-list-grid__container--${order}`}>
      <div className="col col:x3-2" ref={updateContentSpotRefs}>
        <div
          dangerouslySetInnerHTML={{
            __html: contentSpotsDomElements[contentSpot.id],
          }}
          className="grid__content-spot"
        />
      </div>
      <div className="col col:x3">
        <div className="product-list-grid__container">
          {products.map(product => (
            <div key={`t3cr1c2_${product.id}`} className="col col:x1">
              <ProductItemWrapper uniqueTemplateKey="t3cr1c2" product={product} {...props} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export const Template3ColsR1xC3 = props => {
    const { order, contentSpot, contentSpotsDomElements, updateContentSpotRefs } = props;
    return (
        <div className={`product-list-grid product-list-grid__container product-list-grid__container--${order}`}>
            <div className="col col:x3-3" ref={updateContentSpotRefs}>
                <div
                    dangerouslySetInnerHTML={{
                        __html: contentSpotsDomElements[contentSpot.id],
                    }}
                    className="grid__content-spot"
                />
            </div>
        </div>
    );
};

export const Template4ColsR1xC2 = props => {
  const { order, contentSpot, contentSpotsDomElements, products, updateContentSpotRefs } = props;
  return (
    <div className={`product-list-grid product-list-grid__container product-list-grid__container--${order}`}>
      <div className="col col:x2" ref={updateContentSpotRefs}>
        <div
          dangerouslySetInnerHTML={{
            __html: contentSpotsDomElements[contentSpot.id],
          }}
          className="grid__content-spot"
        />
      </div>
      <div className="col col:x2">
        <div className="product-list-grid__container">
          {products.map(product => (
            <div key={`t4cr1c2_${product.id}`} className="col col:x2">
              <ProductItemWrapper uniqueTemplateKey="t4cr1c2" product={product} {...props} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export const Template2ColsR2xC1 = props => {
  const { order, contentSpot, contentSpotsDomElements, products, updateContentSpotRefs } = props;
  return (
    <div className={`product-list-grid product-list-grid__container product-list-grid__container--${order}`}>
      <div className="col col:x2" ref={updateContentSpotRefs}>
        <div
          dangerouslySetInnerHTML={{
            __html: contentSpotsDomElements[contentSpot.id],
          }}
          className="grid__content-spot"
        />
      </div>
      <div className="col col:x2">
        <div className="product-list-grid__container product-list-grid__container--wrap">
          {products.map(product => (
            <div key={`t2cr2c1_${product.id}`} className="col col:x1">
              <ProductItemWrapper uniqueTemplateKey="t2cr2c1" product={product} {...props} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export const Template3ColsR2xC1 = props => {
  const { order, contentSpot, contentSpotsDomElements, products, updateContentSpotRefs } = props;
  return (
    <div className={`product-list-grid product-list-grid__container product-list-grid__container--${order}`}>
      <div className="col col:x3" ref={updateContentSpotRefs}>
        <div
          dangerouslySetInnerHTML={{
            __html: contentSpotsDomElements[contentSpot.id],
          }}
          className="grid__content-spot"
        />
      </div>
      <div className="col col:x3-2">
        <div className="product-list-grid__container product-list-grid__container--wrap">
          {products.map(product => (
            <div key={`t3cr2c1_${product.id}`} className="col col:x2">
              <ProductItemWrapper uniqueTemplateKey="t3cr2c1" product={product} {...props} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export const Template4ColsR2xC1 = props => {
  const { order, contentSpot, contentSpotsDomElements, products, updateContentSpotRefs } = props;
  return (
    <div className={`product-list-grid product-list-grid__container product-list-grid__container--${order}`}>
      <div className="col col:x4" ref={updateContentSpotRefs}>
        <div
          dangerouslySetInnerHTML={{
            __html: contentSpotsDomElements[contentSpot.id],
          }}
          className="grid__content-spot"
        />
      </div>
      <div className="col col:x4-3">
        <div className="product-list-grid__container product-list-grid__container--wrap">
          {products.map(product => (
            <div key={`t4cr2c1_${product.id}`} className="col col:x3">
              <ProductItemWrapper uniqueTemplateKey="t4cr2c1" product={product} {...props} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export const Template3ColsR2xC2 = props => {
  const { contentSpot, contentSpotsDomElements, order, products, updateContentSpotRefs } = props;
  return (
    <div className={`product-list-grid product-list-grid__container product-list-grid__container--${order}`}>
      <div className="col col:x3-2" ref={updateContentSpotRefs}>
        <div
          dangerouslySetInnerHTML={{
            __html: contentSpotsDomElements[contentSpot.id],
          }}
          className="grid__content-spot"
        />
      </div>
      <div className="col col:x3">
        <div className="product-list-grid__container product-list-grid__container--wrap">
          {products.map(product => (
            <div key={`t3cr2c2_${product.id}`} className="col col:x1">
              <ProductItemWrapper uniqueTemplateKey="t3cr2c2" product={product} {...props} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export const Template4ColsR2xC2 = props => {
  const { order, contentSpot, contentSpotsDomElements, products, updateContentSpotRefs } = props;
  return (
    <div className={`product-list-grid product-list-grid__container product-list-grid__container--${order}`}>
      <div className="col col:x2" ref={updateContentSpotRefs}>
        <div
          dangerouslySetInnerHTML={{
            __html: contentSpotsDomElements[contentSpot.id],
          }}
          className="grid__content-spot"
        />
      </div>
      <div className="col col:x2">
        <div className="product-list-grid__container product-list-grid__container--wrap">
          {products.map(product => (
            <div key={`t4cr2c2_${product.id}`} className="col col:x2">
              <ProductItemWrapper uniqueTemplateKey="t4cr2c2" product={product} {...props} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export const TemplateFor1CS = ({ contentSpot, contentSpotsDomElements, updateContentSpotRefs }) => (
  <div className="product-list-grid product-list-grid__container">
    <div className="col col:x1" ref={updateContentSpotRefs}>
      <div
        dangerouslySetInnerHTML={{
          __html: contentSpotsDomElements[contentSpot.id],
        }}
        className="grid__content-spot"
      />
    </div>
  </div>
);

export const TemplateForProducts = props => {
  const { columns, order, products } = props;
  return (
    <div className={`product-list-grid product-list-grid__container product-list-grid__container--${order}`}>
      {products.map(product => (
        <div key={`tfp_${product.id}`} className={`col col:x${columns}`}>
          <ProductItemWrapper uniqueTemplateKey="tfp" product={product} {...props} />
        </div>
      ))}
    </div>
  );
};
